import { useAtom, useAtomValue } from "jotai";
import { AuthRepository } from "@/infrastructure/repositories/auth";
import { errorAtom, isAuthenticatedAtom, isLoadingAtom, setAuthAtom } from "@/store/auth";
import { LogoutUseCase } from "@/core/usecases/auth";
import { useAuth0 } from "@auth0/auth0-react";

interface UseAuthProps {
  isAuthenticated: boolean | null;
  isLoading: boolean;
  error: Error | null;
  logout: () => Promise<void>;
  setAuth: () => Promise<void>;
}

export const useAuth = (): UseAuthProps => {
  const { logout: logoutAuth0 } = useAuth0();

  // Read-only atoms
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);
  const isLoading = useAtomValue(isLoadingAtom);
  const error = useAtomValue(errorAtom);

  // Action atoms
  const [, setAuth] = useAtom(setAuthAtom);

  const logout = async () => {
    const authRepository = new AuthRepository();
    await new LogoutUseCase(authRepository).execute();
    logoutAuth0();
  };

  return {
    isAuthenticated,
    isLoading,
    error,
    setAuth,
    logout,
  };
};
